import { RouteConfig } from "vue-router";

const routes: RouteConfig[] = [
  {
    path: "/",
    component: () => import("../layouts/login.vue"),
    children: [
      { path: "", component: () => import("../views/Index.vue") },
      {
        path: "index",
        name: "login",
        component: () => import("../views/Index.vue"),
      },
    ],
  },
  {
    path: "/reinit",
    component: () => import("../layouts/login.vue"),
    children: [
      {
        path: "/reinit/changePassword",
        component: () => import("../views/reinit.vue"),
      },
    ],
  },
  {
    path: "/home",
    component: () => import("../layouts/MyLayout.vue"),
    children: [{ path: "", component: () => import("../views/Home.vue") }],
    meta: { transitionName: "slide" },
  },
  {
    path: "/rapports",
    component: () => import("../layouts/MyLayout.vue"),
    children: [{ path: "", component: () => import("../views/Rapports.vue") }],
  },
  {
    path: "/tickets",
    component: () => import("../layouts/MyLayout.vue"),
    children: [{ path: "", component: () => import("../views/tickets.vue") }],
  },
  {
    path: "/graphs",
    component: () => import("../layouts/MyLayout.vue"),
    children: [{ path: "", component: () => import("../views/graphs.vue") }],
  },
  {
    path: "/arcole",
    component: () => import("../layouts/MyLayout.vue"),
    children: [{ path: "", component: () => import("../views/Arcole.vue") }],
  },
  {
    path: "/fec",
    component: () => import("../layouts/MyLayout.vue"),
    children: [{ path: "", component: () => import("../views/Fec.vue") }],
  },
  {
    path: "/fec/recurrencesfec",
    component: () => import("../layouts/MyLayout.vue"),
    children: [
      { path: "", component: () => import("../views/RecurrencesFec.vue") },
    ],
  },
  {
    path: "/account",
    component: () => import("../layouts/MyLayout.vue"),
    children: [{ path: "", component: () => import("../views/monCompte.vue") }],
  },
  {
    path: "/recus",
    component: () => import("../layouts/MyLayout.vue"),
    children: [
      { path: "", component: () => import("../views/feuilleCaisse.vue") },
    ],
  },
  {
    path: "/favoris",
    component: () => import("../layouts/MyLayout.vue"),
    children: [
      {
        path: "/configFavoris",
        component: () => import("../views/configFav.vue"),
      },
    ],
  },
  {
    path: "/analyses",
    component: () => import("../layouts/MyLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("../views/analyses.vue"),
        children: [
          {
            path: "/analyses/comptageCaisses/:action",
            component: () => import("../analyses/comptageCaisses.vue"),
          },
          {
            path: "/analyses/recuManagers",
            component: () => import("../analyses/recusManager.vue"),
          },
          {
            path: "/analyses/listExports",
            component: () => import("../analyses/ListExports.vue"),
          },
          {
            path: "/analyses/repartitions",
            component: () => import("../analyses/Repartitions.vue"),
          },
          {
            path: "/analyses/coffre",
            component: () => import("../analyses/coffre.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/bi",
    component: () => import("../layouts/MyLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("../views/validBi.vue"),
      },
    ],
  },
  {
    path: "/tracker",
    component: () => import("../layouts/MyLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("../views/tracker.vue"),
      },
    ],
  },
  {
    path: "/totalKPI",
    component: () => import("../layouts/MyLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("../views/totalHack.vue"),
      },
    ],
  },
  {
    path: "/config",
    component: () => import("../layouts/MyLayout.vue"),
    children: [
      {
        path: "/config",
        component: () => import("../views/configuration.vue"),
        children: [
          {
            path: "/config/users",
            component: () => import("../config/users.vue"),
          },
          {
            path: "/config/sites",
            component: () => import("../config/societes.vue"),
          },
          {
            path: "/config/profils",
            component: () => import("../config/profils.vue"),
          },
          {
            path: "/config/groupes",
            component: () => import("../config/groupes.vue"),
          },
          {
            path: "/config/messages",
            component: () => import("../config/messages.vue"),
          },
          {
            path: "/config/adoria",
            component: () => import("../config/adoria.vue"),
          },
          {
            path: "/config/easilys",
            component: () => import("../config/easilys.vue"),
          },
          {
            path: "/config/consolidations",
            component: () => import("../config/consolidations.vue"),
          },
          {
            path: "/config/miseenroute",
            component: () => import("../bdd/miseenroute.vue"),
          },
          { path: "/config/bdd", component: () => import("../bdd/bdd.vue") },
          {
            path: "/config/rules",
            component: () => import("../config/rules.vue"),
          },
          {
            path: "/config/recurrences",
            component: () => import("../config/recurrences.vue"),
          },
          {
            path: "/config/ecash",
            component: () => import("../config/ecash.vue"),
          },
        ],
      },
    ],
  },
];

// Always leave this as last one
if (process.env.MODE !== "ssr") {
  routes.push({
    path: "*",
    component: () => import("../views/Error404.vue"),
  });
}

export default routes;
